import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicCauchy = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="CAUCHY"
      videos={[
        "https://www.youtube.com/embed/Q-UjRJjPeLs",
      ]}
      takeaways={[
        { text: "Practice as many problems as you can" },
        { text: "If you see anything in terms of e power x or in logarithms, it is better to solve the problem through Cauchy-Euler's type" },
      ]}
      questions={[]} // Empty questions as there were none provided
      exampleVideos={[]} // Empty example videos
    />
);
}

export default ModuleSubtopicCauchy;